
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import { FaBeer, FaCheck, FaEdit, FaRecycle, FaSearch,FaTrash } from "react-icons/fa";
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
// import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

const DeleteTimesheet = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        date: '',
        employee:''
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
    const [base64File, setBase64File] = useState('');
     
    const [formData2, setForm2Data] = useState({
        selectedclient: '',
        selectedsubclient: '',
        task:'',
        minutes:'',
        billedminutes:'',
        budgethours:'',
        remainingbudgethours:'',
        count:'',
        fillingfor:'',
        remarks:''
      });
     
    useEffect(()=>{
      
      getemplist();
     
    },[]);

    const handleChange = (e) => {
        try{
            const { name, value } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: value,
            }));
    
        }catch(e){
            console.log(e);
        }
    };

    const gettimesheetdata = (__page) =>{
        // console.log(formData.date);
        // console.log("form data");
        let page = __page;
        let emparr = [];
        setloading(false);
        timesheetService.showreport_gettimesheetadmin({date:formData.date,userid:formData.employee,page:page}).then((response)=>{
            if(response.status == 200){
                console.log("response data");
                console.log(response);
               
                response.data.data.data.forEach((value,index) =>{
                    emparr.push((<tr>
                        <th>{value.ID}</th>
                        <td>{value.Date}</td>
                        <td>{value.User}</td>
                        <td>{value.client}</td>
                        <td>{value.subclient}</td>
                        <td>budget</td>
                        <td>{value.Task}</td>
                        {/* <td>{value.user_role}</td>
                        <td>{value.user_roletype}</td> */}
                        <td>{value.BilledMinutes}</td>
                        <td>{value.Minutes}</td>
                        <td>{value.Count}</td>
                        <td>{value.Remarks}</td>
                        <td><button className='btn btn-danger' onClick={() => deletetimesheet(value.ID)}><FaTrash/></button></td>
                       
                    </tr>));
                }); 
            
                let totalpage = response.data.data.total; 
                setPages(totalpage);
                setDatacomp(emparr);
                setDatastate(true);
                setloading(true);
                // toast.current.show({severity:'success', summary: "Timesheet", detail:`Timesheet deleted successfully!`, life: 3000});   
            }else{
                setDatacomp([]);  
                setDatastate(false);
                setloading(true);
                setPages(0);
                // toast.current.show({severity:'error', summary: "Timesheet", detail:`Not deleted!`, life: 3000}); 
            }
        }).catch((error)=>{
            setDatacomp([]);  
            setDatastate(false);
            setloading(true);
            setPages(0);
            //  toast.current.show({severity:'error', summary: "Timesheet", detail:`Error!`, life: 3000}); 
        }); 
    }

    const deletetimesheet = (tmid) =>{
        confirmDialog({
            message: 'Are you sure you want to proceed?',
            header: 'Timesheet Deletion',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept: () => {
                   timesheetService.deletetimesheetadmin(tmid).then((response)=>{
                       if(response.status == 200){
                           toast.current.show({severity:'success', summary: "Timesheet", detail:`Timesheet deleted successfully!`, life: 3000});   
                           gettimesheetdata(1);
                        }else{
                           toast.current.show({severity:'error', summary: "Timesheet", detail:`Not deleted!`, life: 3000}); 
                       }
                   }).catch((error)=>{
                        toast.current.show({severity:'error', summary: "Timesheet", detail:`Error!`, life: 3000}); 
                   }); 
            }});
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        gettimesheetdata();
        // console.log("form data");
        // console.log(formData);
        // confirmDialog({
        //     message: 'Are you sure you want to proceed?',
        //     header: 'Timesheet Deletion',
        //     icon: 'pi pi-exclamation-triangle',
        //     defaultFocus: 'accept',
        //     accept: () => {
        //            timesheetService.deletetimesheetadmin(formData).then((response)=>{
        //                if(response.status == 200){
        //                    toast.current.show({severity:'success', summary: "Timesheet", detail:`Timesheet deleted successfully!`, life: 3000});   
        //                }else{
        //                    toast.current.show({severity:'error', summary: "Timesheet", detail:`Not deleted!`, life: 3000}); 
        //                }
        //            }).catch((error)=>{
        //                 toast.current.show({severity:'error', summary: "Timesheet", detail:`Error!`, life: 3000}); 
        //            }); 
        //     }});
        return; 
        // setloading(false);
        // timesheetService.updateRds(obj).then((response)=>{
        //     // console.log(response);
        //     // console.log("response data");
        //     if(response.status == 200){
        //          setloading(true);
        //          toast.current.show({severity:'success', summary: "Rds", detail:`Rds updated successfully!`, life: 3000}); 
        //     }else{
        //          setloading(true);
        //          toast.current.show({severity:'error', summary: "Rds", detail:`Rds Not updated`, life: 3000}); 
        //     }
        // }).catch((error)=>{
        //     // console.log(error); 
        //     // console.log("error data");
        //     setloading(true);
        //     toast.current.show({severity:'error', summary: "Rds", detail:`Error`, life: 3000}); 
        // });
        // addteam({team:formData});
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
  
        if (formData.team_name == '') {
          newErrors.team_name = 'Team name is required';
          valid = false;
        }

        setErrors(newErrors);

       return valid; 
    }

    function addteam({team}){

        if(!validateForm()){
            return;
        }

        adminService.addteam({team:team}).then((response)=>{
        //    console.log('response'); 
        //    console.log(response); 
           if(response.status == 200){
            toast.current.show({severity:'success', summary: "Teams", detail:`Teams updated successfully!`, life: 3000});
           }else{
            toast.current.show({severity:'error', summary: "Teams", detail:`Not updated successfully!`, life: 3000}); 
           }
           _getteam();
        //    setFormData({rolename:''});
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Teams", detail:`Not updated successfully!`, life: 3000}); 
        });
    } 


    function _getteam(){
        let emparr = [];
        setloading(false);

        adminService.getteam().then((response)=>{
           console.log('response'); 
        //    console.log(response.data.data); 
           response.data.data.forEach((value,index)=>{
             console.log(value.name);
             emparr.push(<tr><td>{value.id}</td><td style={{textAlign:'left'}}>{value.team_name}</td></tr>);
           });
           
           setDatacomp(emparr);
           setloading(true);
           setDatastate(true);
        //    const [datacomp,setDatacomp] = useState([]); 
        }).catch((error)=>{
            setloading(true);
            setDatastate(true);
        });
    } 
    
    function getemplist(){
        let member = userdata.id;
        let managerid = member;
        let emparr = [];
        timesheetreportService.getemployeelist({managerid:managerid}).then((response)=>{
           console.log(response);
           response.data.data.forEach((value,index) =>{
              emparr.push((<option value={value.id}>{value.name}</option>));
           });
           setempcomp(emparr);
        }).catch((error)=>{

        });  
    }

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        let pageno = 1;
        if(event.first == 0){
         pageno = 1;    
        }else{
         pageno = ((event.first/rows) + 1);  
        }
        gettimesheetdata(pageno);
        // getUsers(pageno);
        // getreports({reportobj:filterobj,pageno:pageno});
        // console.log(pageno);
    };
   


   return (
        <>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding-two'><h6>{tabname}</h6></div>
            <Toast ref={toast} />
            <ConfirmDialog />
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-4">
                        <label className='pull-left'>Select Date</label>
                        <br/>
                        <input type='date' name='date' required onChange={(e)=>handleChange(e)} className='form-control'/>
                    </div>
                    <div className="col-md-4">
                        <label className='pull-left'>Select Employees</label>
                        <br/>
                        <select name="employee" required onChange={(e)=>handleChange(e)} className='form-control'>
                            <option value="">Select Employee</option>
                            {empcomp}
                        </select>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style'>{!isloaded ? loader.Smallloader() : <></>}</Button>
                        </div>
                    </div>
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                    {isloaded && dataavail ? (<Paginator first={first} rows={rows} totalRecords={totalpages} rowsPerPageOptions={[15]} onPageChange={onPageChange} />) : (<></>)}
                    </div>
                </div>
               
               
                <div className='row'>
                    <div className='col-md-12'>
                    {!isloaded ? loader.Loadermd() : dataavail ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Date</th>
                                <th scope="col">Name</th>
                                <th scope="col">Client</th>
                                <th scope="col">Sub Client</th>
                                <th scope="col">Budget hours</th>
                                <th scope="col">Task</th>
                                {/* <th scope="col">Roles</th>
                                <th scope="col">Role type</th> */}
                                <th scope="col">Billed hours in(Min)</th>
                                <th scope="col">Actual hours in(Min)</th>
                                <th scope="col">Count</th>
                                <th scope="col">Remarks</th>
                                <th scope="col">Action</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            {datacomp}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                </div>
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default DeleteTimesheet;

